import { render, staticRenderFns } from "./info.svg.vue?vue&type=template&id=b632e662&"
import script from "./info.svg.vue?vue&type=script&lang=js&"
export * from "./info.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports